module.exports = __webpack_public_path__ + "img/what_is_physio_splash.14dc49a9.jpg";